<template>
    <div class="cart-discounts-list-form form" ref="cartDiscountsListFormElement">
        <CartDiscountsList class="col-md" @allDiscountsRemoved="close" @discountRemoved="onDiscountRemoved" />
    </div>
</template>

<script setup lang="ts">
    import { useTableAllocationStore } from "@/data/stores/tableAllocation";
    import { Logging } from "@/data/util/Logging";
    import { FloatLabel } from "@/shared/ui/FloatLabel";
    import { onMounted, ref, watch } from "vue";

    import CartDiscountsList from "@/components/cart/CartDiscountsList.vue";

    // define props
    const props = defineProps<{
        onClose: () => unknown;
        onDiscountRemoved: () => void;
    }>();

    const allocation = useTableAllocationStore();

    // define html refs
    const originalAllocationHash = ref<string | undefined>();
    const cartDiscountsListFormElement = ref<HTMLElement | null>(null);

    const emit = defineEmits(["close"]);

    function close() {
        emit("close");
        props.onClose();
    }

    watch(
        () => allocation.hash,
        () => {
            if (allocation.hash != originalAllocationHash.value) {
                // if allocation has changed - close this modal
                Logging.LogInfo(
                    `Closing CartDiscountsListPopoverForm because allocation has changed - previous ${originalAllocationHash.value}, current ${allocation.hash}`
                );
                close();
            }
        }
    );

    onMounted(() => {
        originalAllocationHash.value = allocation.hash;
        FloatLabel.bind($(cartDiscountsListFormElement.value!));
    });
</script>

<style lang="scss">
    .cart-discounts-list-form {
        padding: 0 0 3.5em;
    }
</style>
